import { useState } from 'react'
import { AccountModule } from '@core/modules/account/account.module'
import { ASM_DIALOGS_MAP, DialogService } from '@core/services/dialog'
import { Switch } from '@components/buttons/switch'
import ContentItem from '@components/page-content/content-item'
import Typography from '@/ui/components/typography'
import { TTheme, useCustomTheme } from '@/core/theme'
import { Card } from '@routes/settings/routes/account/settings.account.route.styles'
import { MfaDescription, MfaTitle } from './mfaSettings.styles'

const MfaSettings = () => {
    const theme = useCustomTheme() as TTheme
    const [isLoading, setIsLoading] = useState(false)

    const handleOnEnforceMfaClick = async () => {
        if (!AccountModule.isMfaEnforced) {
            DialogService.showDialog(ASM_DIALOGS_MAP.ENFORCE_MFA)
        } else {
            setIsLoading(true)
            await AccountModule.setMfaEnforcement(false)
            setIsLoading(false)
        }
    }

    return (
        <Card>
            <MfaTitle>
                <Typography
                    component="p"
                    variant="m-regular"
                    color={theme.colors.greys[800]}
                >
                    MFA Settings
                </Typography>
            </MfaTitle>
            <MfaDescription>
                <Typography
                    component="p"
                    variant="s-regular"
                    color={theme.colors.greys[500]}
                    whiteSpaceRule="normal"
                >
                    When enabled, all users on this account must set up
                    multi-factor authentication at their next sign-in for an
                    added layer of security.
                </Typography>
            </MfaDescription>
            <ContentItem label="Enforce MFA">
                <Switch
                    loading={isLoading}
                    checked={AccountModule.isMfaEnforced}
                    onChange={handleOnEnforceMfaClick}
                    testId="toggle"
                />
            </ContentItem>
        </Card>
    )
}

export default MfaSettings
